import PropTypes from 'prop-types';

import Icon from '@/components/common/iconedLinks/Icon';

import styles from './InfoCard.module.scss';

export const InfoCard = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  data, title = null, desc = null, img = null, customClass = '', center = false, borderColor = { color: '' }, breakpoint = ''
}) => {
  const isBorderColorAnObject = typeof borderColor === 'object';

  const computedClassName = [
    styles.container,
    customClass,
    center && styles.center,
    isBorderColorAnObject && borderColor.color !== '' && styles.bordered,
    !isBorderColorAnObject && borderColor && styles.bordered
  ].filter(Boolean).join(' ');

  const titleClassName = [
    styles.title,
    title.customClass
  ].filter(Boolean).join(' ');

  return (
    <div className={computedClassName} style={{ borderColor }} data-test-id="info-card-content">
      {img && (
        <Icon
          src={img.src}
          width={img.width || 32}
          height={img.height || 32}
          alt={img.alt}
          lazy
        />
      )}
      <div className={titleClassName} dangerouslySetInnerHTML={{ __html: title.content }} />
      <div className={desc.customClass} dangerouslySetInnerHTML={{ __html: desc.content }} />
    </div>
  );
};

InfoCard.propTypes = {
  title: PropTypes.shape({
    content: PropTypes.string.isRequired,
    customClass: PropTypes.string
  }).isRequired,
  desc: PropTypes.shape({
    content: PropTypes.string.isRequired,
    customClass: PropTypes.string
  }).isRequired,
  img: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  customClass: PropTypes.string,
  center: PropTypes.bool,
  borderColor: PropTypes.string
};

export default InfoCard;
